module.exports = __webpack_public_path__ + "static/img/frame-foundation-8m-x-4m_256.c92f688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frame-foundation-8m-x-4m_256.png
// module id = k0oU
// module chunks = 0